import {InputText} from '@/components/Form/index.mjs'
import FormItemBizProp from '../components/FormItemBizProp.jsx'
import FormChooseDesign from '../_DESIGN/FormChooseDesign.jsx'
import {FormItemUiName, FormItemUiUserCode} from '../UI/FormChooseUi.jsx'
import Model from './ModelUe.mjs'

export const FormItemUeName = props => (
    <FormItemBizProp
        Model={Model}
        prop="ueName"
        {...props}
    >
        <InputText allowClear />
    </FormItemBizProp>
)

export default function FormChooseUe(props) {
    return (
        <FormChooseDesign {...props}>
            <FormItemUiUserCode />
            <FormItemUiName />
            <FormItemUeName />
        </FormChooseDesign>
    )
}
